
export default [
  {
    path: "/qspiDQMP",
    name:"dqmp",
    component: () =>
      import("@/components/page/QSPI/DQMP/dqmpLists"),
    meta: { title: "DQMP" },
  },
  {
    path: "/qspiDQMP/detail",
    name:"dqmpDetail",
    component: () =>
      import("@/components/page/QSPI/DQMP/dqmpDetail"),
    meta: { title: "维护DQMP评分" },
  },
];
